<div class="container py-3">
  <div *ngIf="token !== undefined">
    <div class="row" *ngIf="newsLetterList && newsLetterList.length > 0">
      <div
        class="col-lg-4 col-md-6 col-6"
        *ngFor="let list of newsLetterList; let i = index"
      >
        <div class="card newsletter_dev">
          <div class="logo-image text-center">
            <img [src]="list.incubatorLogoFile" alt="" />
          </div>
          <div style="padding: 20px">
            <h5 class="newsheading">{{ list.title }}</h5>
            <div class="d-flex">
              <span
                ><span style="font-size: 12px; color: gray; margin-left: 3px"
                  >Posted : </span
                >{{ list.newsletterDate }}</span
              >
              <span class="ml-auto"
                ><a
                  [href]="list.newsletterName"
                  target="_blank"
                  style="color: orange"
                  >View more</a
                ></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="text-center"
      *ngIf="!newsLetterList || !newsLetterList.length === 0"
    >
      <div class="no-data-div image-align">
        <img
          style="padding-top: 80px"
          src="assets/images/startupTn-new-logo.png"
          class="img-fluid"
          alt=""
        />
        <h6>Coming soon</h6>
      </div>
    </div>
  </div>
</div>
